export var OS = /*#__PURE__*/function (OS) {
  OS["Android"] = "android";
  OS["IOS"] = "ios";
  return OS;
}({});
export var Stores = /*#__PURE__*/function (Stores) {
  Stores["Android"] = "googlePlay";
  Stores["Huawei"] = "appGallery";
  Stores["IOS"] = "appStore";
  Stores["RuStore"] = "ruStore";
  return Stores;
}({});